import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { EditorBookingItemSettingCapacity } from '../editor-booking-item-setting/editor-booking-item-setting-capacity.model';


@Component({
    selector: 'eas-editor-booking-item-setting-summary-capacity',
    templateUrl: './editor-booking-item-setting-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingSummaryCapacityComponent implements OnChanges, OnInit {
  @Input() itemSetting: EditorBookingItemSettingCapacity;
  @Input() first: boolean;
  @Input() last: boolean;

  summary: string;

  constructor() {

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSetting) {
      this.summary = this.getSummary();
    }
  }

  getSummary(): string {
    let summary: string;

    if (this.itemSetting.available !== null) {
      summary = $localize `${this.itemSetting.available} available places`;
    }

    if (summary === undefined) {
      return '';
    }

    summary = this.first ? summary.charAt(0).toUpperCase() + summary.slice(1) : summary;
    if (!this.last) {
      summary = `${summary}, `;
    }

    return summary;
  }
}
